import { useSuspenseQuery } from '@tanstack/react-query';
import api from '../../api';
import { type Shop } from '../../api/shop';

type ShopQueryKey = ['shops', string];

export function useShop(code: string) {
  return useSuspenseQuery<Shop, Error, Shop, ShopQueryKey>({
    queryKey: ['shops', code],
    queryFn: () => api.shop.get(code),
  });
}
